"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateAndTimeRangeToPeriod = exports.datesAndTimeRangeToPeriods = void 0;
const date_fns_1 = require("date-fns");
const _1 = require(".");
/**
 * 指定された日付の配列とTimeRangeからPeriodsを生成する
 * @param dates
 * @param timeRange
 * @return Periods
 */
const datesAndTimeRangeToPeriods = (dates, timeRange) => {
    const periods = dates.map((date) => (0, exports.dateAndTimeRangeToPeriod)(date, timeRange));
    return new _1.Periods(periods);
};
exports.datesAndTimeRangeToPeriods = datesAndTimeRangeToPeriods;
/**
 * 指定された日付と時間帯からPeriodを生成する
 * @param date
 * @param timeRange
 * @return Periods
 */
const dateAndTimeRangeToPeriod = (date, timeRange) => {
    const { startTime, endTime } = timeRange;
    return new _1.Period((0, date_fns_1.set)(date, {
        hours: startTime.hour,
        minutes: startTime.min
    }), (0, date_fns_1.set)(date, {
        hours: endTime.hour,
        minutes: endTime.min
    }));
};
exports.dateAndTimeRangeToPeriod = dateAndTimeRangeToPeriod;
//# sourceMappingURL=generateDateAndTimeRangePeriods.js.map